jQuery(document).ready(function () {
    const currentUrl = window.location.href;

    $('.share-page').each(function () {
        var shareUrl;
        var socialMedia = $(this).data('social-media');

        switch (socialMedia) {
            case 'facebook':
                shareUrl = 'http://www.facebook.com/sharer.php?u=' + currentUrl;
                break;
            case 'twitter':
                shareUrl = 'http://twitter.com/intent/tweet?url=' + currentUrl;
                break;
            case 'linkedin':
                shareUrl = 'http://www.linkedin.com/shareArticle?url=' + currentUrl;
                break;
            default: break;
        }

        if (shareUrl) {
            $(this).attr('href', shareUrl);
        }
    });
});
